/* eslint-disable */
const breakpoints = {
  values: {
    xs: 0,
    sm: 600,
    mdOpen: 900,
    md: 960,
    lg: 1024,
    xl: 1920,
  },
};

export default breakpoints;
